import React from 'react';

export interface TastesLikeHomeShef {
  background: string;
  category: string;
  categoryIllustrationUrl?: string;
  categoryIcon?: React.ReactNode;
  dishName: string;
  dishImage: string;
  dishDescription: string;
  shefName: string;
  shefPic: string;
  subcuisines: string[];
}

export const INDIAN_TASTES_LIKE_HOME: TastesLikeHomeShef[] = [
  {
    background: 'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/landing/tastes-like-home/Kerala+bg.png',
    category: 'Kerala, India',
    categoryIllustrationUrl:
      'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/category-pages/indian-cuisine/isolated-illustrations/kerala.png',
    dishName: 'Kerala Chicken Curry',
    dishImage: 'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/landing/tastes-like-home/Kerala+dish.png',
    dishDescription: 'Chicken simmered in a rich curry made from coconut milk and freshly ground Kerala spices.',
    shefName: 'Linta',
    shefPic: 'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/landing/tastes-like-home/linta_kerala.png',
    subcuisines: ['South Indian', 'Kerala', 'Fusion'],
  },
  {
    background: 'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/landing/tastes-like-home/Punjabi+bg.png',
    category: 'Punjab, India',
    categoryIllustrationUrl:
      'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/category-pages/indian-cuisine/isolated-illustrations/punjab.png',
    dishName: 'Sookhi Masala Arbi',
    dishImage: 'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/landing/tastes-like-home/Punjabi+dish.png',
    dishDescription:
      'A dry curry made from taro root, green chili, and a blend of ground spices. Crisp and tasty, this dish is best served with homemade dal or parantha.',
    shefName: 'Pooja',
    shefPic: 'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/landing/tastes-like-home/pooja_punjabi.png',
    subcuisines: ['North Indian', 'Punjabi', 'Vegetarian', 'South Asian'],
  },
  {
    background:
      'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/landing/tastes-like-home/Indian+fusion+bg.png',
    category: 'Indian Fusion',
    categoryIllustrationUrl:
      'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/category-pages/indian-cuisine/isolated-illustrations/india.png',
    dishName: 'Butter Chicken',
    dishImage:
      'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/landing/tastes-like-home/Indian+fusion+dish.png',
    dishDescription:
      'Boneless tandoori chicken simmered in a mild tomato, cashew, and cream sauce with a house blend of spices.',
    shefName: 'Wayne X.',
    shefPic: 'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/landing/tastes-like-home/wayne_fusion.png',
    subcuisines: ['North Indian', 'Indo-Chinese', 'Fusion', 'Indian'],
  },
  {
    background:
      'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/landing/tastes-like-home/North+Indian+bg.png',
    category: 'North Indian',
    categoryIllustrationUrl:
      'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/category-pages/indian-cuisine/isolated-illustrations/north-india.png',
    dishName: 'Louki Kofta',
    dishImage:
      'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/landing/tastes-like-home/North+Indian+dish.png',
    dishDescription:
      'Bottle gourd fritters braised in a rich gravy made of onion, tomatoes, and traditional spices. Best enjoyed with homemade paratha or roti.',
    shefName: 'Savita K.',
    shefPic: 'https://shef-general.s3.us-west-1.amazonaws.com/assets/img/landing/tastes-like-home/savita_north.png',
    subcuisines: ['North Indian', 'Indian'],
  },
];
